import { Menu } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
    ADMIN_MOBILE_PRIMARY_NAV,
    adminMobileMoreIsActive,
    adminMobileOverflowItems,
    adminNavItemIsActive,
} from '@/constants/admin-nav';

type Props = {
    moreOpen: boolean;
    onToggleMore: () => void;
};

export function AdminBottomNav({ moreOpen, onToggleMore }: Props) {
    const { pathname } = useLocation();
    const moreItems = adminMobileOverflowItems();
    const moreActive = moreOpen || adminMobileMoreIsActive(pathname, moreItems);

    return (
        <nav
            className="fixed bottom-0 left-0 right-0 z-[25] flex items-center md:hidden bg-background/95 backdrop-blur-lg border-t border-border"
            style={{
                height: 'calc(var(--bottom-nav-height) + var(--safe-area-bottom))',
                paddingBottom: 'var(--safe-area-bottom)',
                paddingLeft: 'max(0.25rem, var(--safe-area-left))',
                paddingRight: 'max(0.25rem, var(--safe-area-right))',
            }}
            aria-label="Navegación principal"
        >
            {ADMIN_MOBILE_PRIMARY_NAV.map((item) => {
                const { path, icon: Icon, label } = item;
                const active = adminNavItemIsActive(pathname, item);
                return (
                    <NavLink
                        key={path}
                        to={path}
                        end={item.end}
                        className="flex min-w-0 flex-1 flex-col items-center justify-center gap-1 px-0.5 py-1"
                    >
                        <span
                            className={cn(
                                'inline-flex items-center justify-center rounded-xl p-1.5',
                                active ? 'bg-primary text-primary-foreground' : 'text-muted-foreground',
                            )}
                        >
                            <Icon className="h-5 w-5" />
                        </span>
                        <span
                            className={cn(
                                'max-w-full truncate text-[10px] leading-none',
                                active ? 'font-semibold text-foreground' : 'font-medium text-muted-foreground',
                            )}
                        >
                            {label}
                        </span>
                    </NavLink>
                );
            })}
            <button
                type="button"
                className="flex min-w-0 flex-1 flex-col items-center justify-center gap-1 px-0.5 py-1"
                aria-label={moreOpen ? 'Cerrar menú' : 'Más páginas'}
                aria-expanded={moreOpen}
                onClick={onToggleMore}
            >
                <span
                    className={cn(
                        'inline-flex items-center justify-center rounded-xl p-1.5',
                        moreActive ? 'bg-primary text-primary-foreground' : 'text-muted-foreground',
                    )}
                >
                    <Menu className="h-5 w-5" />
                </span>
                <span
                    className={cn(
                        'text-[10px] leading-none',
                        moreActive ? 'font-semibold text-foreground' : 'font-medium text-muted-foreground',
                    )}
                >
                    Más
                </span>
            </button>
        </nav>
    );
}
